import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, Clock, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const KIND = { pools: "Soru havuzu", activities: "Etkinlik", rooms: "Oyun" };
const linkOf = (k, id) => ({ pools: `/ogretmen/havuzlar/${id}`, activities: "/ogretmen/etkinlikler", rooms: "/ogretmen/oyunlar" }[k]);
const when = (iso) => (iso ? new Date(iso).toLocaleString("tr-TR") : "");

export default function ReviewsPage() {
  const [data, setData] = useState({ pending: [], history: [] });
  const navigate = useNavigate();
  useEffect(() => { api.get("/badges/reviews").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-8" data-testid="reviews-page">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold">Onaylar</h1>
        <p className="text-slate-400 mt-1">Uzman Onaylı rozet talepleri ve verilen kararların geçmişi.</p>
      </div>
      <section className="space-y-3">
        <h2 className="font-display text-2xl font-bold flex items-center gap-2"><Clock className="h-5 w-5 text-[#FACC15]" />Bekleyen talepler · {data.pending.length}</h2>
        {data.pending.length === 0 && <p className="text-sm text-slate-400">Bekleyen talep yok.</p>}
        <div className="grid md:grid-cols-2 gap-3">
          {data.pending.map((p) => (
            <div key={p.item_id} className="panel p-4 flex items-center gap-3" data-testid={`review-pending-${p.item_id}`}>
              <div className="flex-1 min-w-0">
                <p className="eyebrow">{KIND[p.kind]} · {when(p.at)}</p>
                <p className="font-bold truncate">{p.item_name}</p>
                <p className="text-xs text-slate-400">{p.owner_name}</p>
              </div>
              <Button size="sm" onClick={() => navigate(linkOf(p.kind, p.item_id))} data-testid={`review-open-${p.item_id}`}>İncele</Button>
            </div>
          ))}
        </div>
      </section>
      <section className="space-y-3">
        <h2 className="font-display text-2xl font-bold">Onay geçmişi</h2>
        {data.history.length === 0 && <p className="text-sm text-slate-400">Henüz karar verilmedi.</p>}
        <div className="space-y-2">
          {data.history.map((h) => (
            <div key={h.id} className="panel p-4 flex gap-3" data-testid={`review-history-${h.id}`}>
              {h.approve ? <BadgeCheck className="h-6 w-6 text-[#4ADE80] shrink-0" /> : <XCircle className="h-6 w-6 text-red-400 shrink-0" />}
              <div className="min-w-0">
                <p className="text-sm"><b>{h.item_name}</b> <span className="text-slate-400">({KIND[h.kind]})</span> · <span className={h.approve ? "text-[#4ADE80]" : "text-red-300"}>{h.approve ? "Onaylandı" : "Reddedildi"}</span></p>
                <p className="text-xs text-slate-400">{h.reviewer} · talep eden {h.requester || "—"} · {when(h.at)}</p>
                {h.note && <p className="text-sm text-slate-200 mt-1 border-l-2 border-white/20 pl-2">{h.note}</p>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
